<template>
<div class="pp-content">
    <div @click="$root.mobileBack()" v-if="$root.view == 'mobile'" class="pp-mobile-back">
        <i class="fa fa-fw fa-angle-left"></i>
    </div>
    <loading-indicator v-if="loading"></loading-indicator>
    <div v-if="album" class="pp-album-view">
        <div v-if="$root.view != 'mobile'" class="pp-album-view__sidebar">
            <div class="pp-album-view__artwork">
                <img :src="album.artwork">
            </div>
            <div class="pp-album-view__summary" v-html="album.summary"></div>
            <div class="pp-album-view__tabs">
                <div class="pp-album-view__tabs__headers">
                    <div v-for="tab in album.tabs"
                       :class="{'pp-album-view__tabs__headers__header':1, 'pp-album-view__tabs__headers__header--active': tab.active}"
                       @click="switchTab(tab.id)">
                        {{ tab.label }}
                    </div>
                </div>
                <div v-for="tab in album.tabs" v-if="tab.active" class="pp-album-view__tabs__content" v-html="tab.content">
                </div>
            </div>
        </div>
        <div v-if="$root.view == 'mobile'" class="pp-album-view__mobile-header">
            <div class="pp-album-view__mobile-slider">
                <swiper :options="sliderOptions" ref="albumSlider">
                    <swiper-slide>
                        <div class="pp-album-view__artwork">
                            <img :src="album.artwork">
                        </div>
                        <div class="pp-album-view__title">
                            {{ album.title }}
                        </div>
                        <div class="pp-album-view__artist">
                        </div>
                    </swiper-slide>
                    <swiper-slide>
                        <div class="pp-album-view__summary" v-html="album.summary"></div>
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
            </div>
            <!--
            <a class="pp-album-view__mobile-header__button">
                More information <i class="fa fa-fw fa-angle-right"></i>
            </a>
            -->
        </div>
        <div class="pp-album-view__main">
            <div v-if="$root.view != 'mobile'" class="pp-album-view__title">
                {{ album.title }}
            </div>
            <div class="pp-album-view__actions">
                <div @click="playAlbum" class="pp-album-view__action">
                    <i class="fa fa-fw fa-play"></i> Play album
                </div>
                <div @click="queueAlbum" class="pp-album-view__action">
                    <i class="fa fa-fw fa-indent"></i> Add tracks to queue
                </div>
            </div>
            <track-list :items="album.tracks"></track-list>
        </div>
    </div>
</div>
</template>


<script>
import EventBus from '../EventBus.js';
import TrackList from '../components/TrackList.vue';
import LoadingIndicator from '../components/LoadingIndicator.vue';
import { api } from '../API.js';

export default {
    name: 'view-album',
    components: {
        LoadingIndicator,
        TrackList,
    },
    watch: {
        '$route': 'fetchData'
    },
    methods: {
        fetchData() {
        //    this.loading = false;//true;
        //    return;

            this.loading = true;

            console.log('fetchData');

            api.get('/albums/{{id}}', {
                id: this.$route.params.id
            }, {
                with: ['tracks']
            }, (data) => {
                this.album = data.album;
                this.loading = false;
            }, () => {
                console.log('Error!');
            });
        },
        switchTab(tabId) {
            for (let tab of this.album.tabs) {
                tab.active = tab.id == tabId;
            }
        },
        playAlbum() {
            EventBus.emit('core.track.play', {
                track: this.album.tracks[0],
                context: this.album.tracks
            });
        },
        queueAlbum() {
            for (let track of this.album.tracks) {
                EventBus.emit('core.queue.addTrack', {
                    track: track,
                    next: false
                });
            }
        }
    },
    mounted() {
        this.fetchData();
    },
    data() {
        return {
            sliderOptions: {
                pagination: '.swiper-pagination',
                paginationClickable: true,
                notNextTick: true,
                centeredSlides: true
            },
            loading: true,
            album: null
        };
    },

}
</script>



// WEBPACK FOOTER //
// ViewAlbum.vue?3507f640